export const validateEmailDomain = (value?: string) => {
  const valueSplitted = value?.split('.');
  const domain = valueSplitted && valueSplitted[valueSplitted.length - 1];

  return !!(domain && domain.length > 1);
};
